export default "__VITE_ASSET__eBWZdZm4__"